export enum BulkImportUserSummaryType {
  Errors = 'errors',
  Existing = 'existing',
  NewUsers = 'new_users',
  ToBeDeleted = 'to_be_deleted',
  Total = 'total',
}
